var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadLightblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.6668C0 46.1145 0.447715 45.6668 1 45.6668H47C47.5523 45.6668 48 46.1145 48 46.6668V50.0002C48 50.5524 47.5523 51.0002 47 51.0002H0.999999C0.447714 51.0002 0 50.5524 0 50.0002V46.6668ZM26.6667 10.5415V39.3335C26.6667 39.8858 26.219 40.3335 25.6667 40.3335H22.3333C21.781 40.3335 21.3333 39.8858 21.3333 39.3335V10.5415L5.85111 26.0263C5.46059 26.4169 4.82738 26.4169 4.43683 26.0263L2.0804 23.6699C1.68989 23.2794 1.68987 22.6463 2.08036 22.2557L23.2929 1.04069C23.6834 0.650122 24.3166 0.650104 24.7071 1.04064L45.9196 22.2531C46.3101 22.6436 46.3101 23.2767 45.9196 23.6673L43.563 26.0238C43.1725 26.4143 42.5394 26.4144 42.1489 26.024L26.6704 10.5506C26.668 10.5482 26.6667 10.5449 26.6667 10.5415Z",
    fill: "#7FA0F9",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadLightblue);
export default __webpack_public_path__ + "static/media/icon-upload-lightblue.267889698d95c72709817c27fe9fd2bf.svg";
export { ForwardRef as ReactComponent };